<template>
    <div>
        <ViewItem v-if="!!template" :item="template" @success="alertSuccess" @delete-item="deleteType"
            @cancel="template = null" @error="alertError"></ViewItem>

        <b-overlay v-else :show="tableLoading" rounded="sm" >
            <ListItems title="Templates" @show-item="showTemplate" ref="table">
                <import-form
                :subject="$translate('workflow_template')"
                v-model="importModal"
                @cancel="hideModal()"
                :fields="inventoryFields"
                :upload-record="uploadInventoryRecord"
                :isworkflowtemplate="isworkflowtemplate"
                settings-key-name="WorkflowTemplateUploadKey"
              ></import-form>
                <!-- <b-button id="add-template-btn" block variant="primary" @click="template = {}">
                    <img v-b-tooltip.hover :title="$addLabel()" v-if="hasPermissionCreate"
                        src="@/assets/images/icon/blue-add.svg">
                </b-button> -->
                <div
                class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button"
            >
                <b-button
                id="add-checkoff-btn"
                variant="blue-icon"
                v-b-tooltip.hover
                :title="$addLabel()"
                v-if="hasPermissionCreate"
                 @click="template = {}"
                >
                <img src="@/assets/images/icon/gradient-add.svg" />
                </b-button>
  
                <b-button
                id="import-checkoff-item-btn"
                variant="blue-icon"
                v-b-tooltip.hover
                :title="$translate('import')"
                @click="openModel()"
                v-if="hasPermissionCreate"
              >
                <img src="@/assets/images/icon/import.svg" />
              </b-button>
              
            </div>
            </ListItems>
        </b-overlay>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'
import importMixins from "@/mixins/importMixins";
import ImportForm from "@/components/ImportForm.vue";
const inventoryFields = [
  { name: "name", label: "name", required: true, type: "text" },
 
  {
    name: "description",
    label: "description",
    required: false,
    type: "text",
  },
  {
    name: "roles_for_notification",
    label: "roles_for_notification",
    required: false,
    type: "text",
  },
  {
    name: "is_completed",
    label: "is_completed",
    required: false,
    type: "text",
  },
  {
    name: "is_completed_value_type_format",
    label: "is_completed_value_type_format",
    required: false,
    type: "text",
    options: [
      { 'value': 0, 'text': 'No'},
      { 'value': 1, 'text': 'Yes'},
    ]
  },
  {
    name: "archived",
    label: "archived",
    required: false,
    type: "text",
  },
  {
    name: "archived_value_type_format",
    label: "archived_value_type_format",
    required: false,
    type: "text",
    options: [
      { 'value': 0, 'text': 'No'},
      { 'value': 1, 'text': 'Yes'},
    ]
  },
  {
    name: "sequence_no",
    label: "sequence_no",
    required: false,
    type: "text",
  },
  
  {
    name: "workflow_type",
    label: "workflow_type",
    required: false,
    type: "text",
  },
  {
    name: "users_or_role_for_notification",
    label: "users_for_notification",
    required: false,
    type: "text",
  },
  
 

];
export default {
    name: 'reviewTemplates',
    components: {
        ListItems,
        ViewItem,
        ImportForm
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins, errorHandlingMixins,importMixins],
    data: () => {
        return {
            template: null,
            tableLoading: false,
            inventoryFields,
            importModal: false,
            isworkflowtemplate : 'yes',
        }
    },
    async created() {
        this.$store.dispatch('checkoffTypes/fetchAll')
        this.tableLoading = true;
        await this.$store.dispatch('checkoffTemplates/fetchAll', {})
        this.tableLoading = false;
    },

    computed: {
        componentName() { return this.$translate('review_template') },
        templates() {
            const templates = this.$store.state.checkoffTemplates.templates
            console.log('templates', templates)
            return templates
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        showTemplate(id) {
            this.template = this.templates.find(x => x.id === id)
        },

        async alertSuccess(action, message) {
            //const message= isUpdated? 'Review template updated successfully' : 'Review template created successfully'
            //const action= isUpdated? 'Updated':'Created'

            this.genericToast(this.componentName, this.$translate(`${action}d`), 'success', `${this.componentName} ${message}`)
            await this.$store.dispatch('checkoffTemplates/fetchAll', {forceReload: true})
            //this.doToast('Success', message, 'success')
            this.template = null
        },

        alertError(error) {
            // let message = error.message
            // console.log('mmm', message)
            // const interror = 'Internal Server Error'
            // if (interror == error.message) {

            this.genericToast(`${this.componentName}`, this.$translate('error'), 'danger', `${error.message}`)

            // }
        },
        async uploadInventoryRecord(
      dataRecord,
      statusRecord,
      { check, message, field },
      statuses,
      setLoading
    ) {
      try {
        let {
          name,
          description,
          roles_for_notification,
          is_completed, 
          archived,
          sequence_no,
          workflow_type,
          users_or_role_for_notification, 
        
         
        } = dataRecord;

      

      

        const is_mandatory_value_types = [
          {
            'name': 'Yes',
            'id': 1,
          },
          {
            'name': 'No',
            'id': 0,
          }
        ]

       

   
        name = name.trim();
        description = description.trim();
        roles_for_notification =roles_for_notification.trim();
        sequence_no = sequence_no.trim();
        workflow_type = workflow_type.trim();

        is_completed = is_completed == 'Yes' || is_completed == 'yes' || is_completed == 'YES' ? 1 : 0;
        archived = archived == 'Yes' || archived == 'yes' || archived == 'YES' ? 1 : 0;
        
        let usersArray = users_or_role_for_notification.split(',');
        let roleArray  = roles_for_notification.split(',');
        const param = {
          name,
          description,
          roleArray,
          is_completed, 
          archived,
          sequence_no,
          workflow_type,
          usersArray, 
        
        };
        console.log({ param });

        const res = await this.$store.dispatch("checkoffTemplates/upload", param);
        this.tableLoading = true;
        await this.$store.dispatch('checkoffTemplates/fetchAllAfterUpdate', {forceReload : true})
        this.tableLoading = false;
        // console.log("response:", res);
        // set status to complete if the upload was successful
        statusRecord.status = statuses.COMPLETE;
      } catch (err) {
        console.error("err", err);
        statusRecord.error_list =
          typeof err.message == "string"
            ? [["error", [err.message]]]
            : Object.entries(err.message);
        statusRecord.status = statuses.ERROR;
      } finally {
        // setLoading(false);
      }
    },
    openModel(){
     
      this.importModal = true;   
     },
    },
}
</script>
<style></style>
